import React from 'react';

const Divider = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center w-full py-8 ${className}`}>
      <div className="w-16 h-px bg-gold/40"></div>
      <div className="w-2 h-2 rotate-45 border border-gold/60 mx-4"></div>
      <div className="w-16 h-px bg-gold/40"></div>
    </div>
  );
};

export default Divider;